import { render, staticRenderFns } from "./webcam.vue?vue&type=template&id=84ffcfe0&"
import script from "./webcam.vue?vue&type=script&lang=js&"
export * from "./webcam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84ffcfe0')) {
      api.createRecord('84ffcfe0', component.options)
    } else {
      api.reload('84ffcfe0', component.options)
    }
    module.hot.accept("./webcam.vue?vue&type=template&id=84ffcfe0&", function () {
      api.rerender('84ffcfe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21jfgjCJGzf73/JS/webcam.vue"
export default component.exports